module.exports = __webpack_public_path__ + "assets/img/sh4.de29549c.jpg";